/**
 * Profile menu of header section on dashboard page
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { DropdownLayout, Tooltip, Button } from 'wix-style-react'
import PersonIcon from 'react-icons/lib/md/perm-identity'

import history from '../history'
import { logout } from 'controllers/auth'

const Container = styled.div`
  width: 180px;
  height: ${props => props.rows * 40}px;
  padding-top: 0.2em;
  text-align: left;

  & div {
    box-shadow: none;
    border-radius: 0;
  }
`
const OptionContainer = styled.div`
  padding-left: 10px;
`

const LOGOUT = 'LOGOUT'
const SUBSCRIPTION = 'SUBSCRIPTION'
const AUTH = 'AUTH'
const ACCOUNT = 'ACCOUNT'

class ProfileMenu extends Component {

  handleMenuClick = (item) => {
    switch (item.id) {
      case AUTH:
        history.push('/auth')
        break
      case SUBSCRIPTION:
        history.push('/plan')
        break
      case LOGOUT:
        this.props.dispatch(logout())
        break
      case ACCOUNT:
        history.push('/account')
        break
    }
  }

  options = () => {
    const { authData } = this.props
    if (authData.isAnonymous) {
      return [
        { id: AUTH, value: <OptionContainer>Register</OptionContainer> }
      ]
    } else {
      return (
        [
          { id: ACCOUNT, value: <OptionContainer>Account Settings</OptionContainer> },
          { id: SUBSCRIPTION, value: <OptionContainer>Subscription Plan</OptionContainer> },
          // {id: 3, value: <OptionContainer>Billing & Payments</OptionContainer>},
          { id: LOGOUT, value: <OptionContainer>Logout</OptionContainer> },
        ]
      )
    }
  }

  renderMenu = () => {
    const optionsArray = this.options()
    let selectedId
    if (history.location.pathname === '/account') selectedId = ACCOUNT
    if (history.location.pathname === '/plan') selectedId = SUBSCRIPTION
    return (
      <Container rows={optionsArray.length}>
        <DropdownLayout
          visible
          options={optionsArray}
          onSelect={this.handleMenuClick}
          selectedId={selectedId}
        />
      </Container>
    )
  }

  render () {
    return (
      <Tooltip
        hideDelay={1000}
        content={this.renderMenu()}
        onClickOutside={null}
        onShow={null}
        shouldCloseOnClickOutside
        placement='bottom'
        moveArrowTo={-40}
        moveBy={{x: -70, y: 12}}
      >
        <Button theme='icon-standardsecondary'>
          <PersonIcon />
        </Button>
      </Tooltip>
    )
  }
}

ProfileMenu.propTypes = {
  authData: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  authData: state.authData
})

export default connect(mapStateToProps)(ProfileMenu)



// WEBPACK FOOTER //
// ./src/components/dashboard/ProfileMenu.js